import { Component, Output, EventEmitter, Input, SimpleChanges, OnChanges, inject } from '@angular/core';
import { UtilityService } from 'src/app/core/services/utility.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-read-only-pdf-viewer',
  templateUrl: './read-only-pdf-viewer.component.html',
  styleUrls: ['./read-only-pdf-viewer.component.css'],
})
export class ReadOnlyPdfViewerComponent implements OnChanges {
  private readonly utilityService = inject(UtilityService);
  private readonly sanitizer = inject(DomSanitizer);

  @Input() attachment: FileInfo;
  @Input() defaultZoom: string = null;
  @Output() alertCreated: EventEmitter<Alert> = new EventEmitter<Alert>();
  pdfUrl: SafeResourceUrl | null = null;
  downloadURL: string | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.attachment) {
      this.getPDFData(this.attachment);
    }
  }

  private getPDFData(attachment: FileInfo): void {
    if (attachment == null) {
      this.pdfUrl = null;
      this.downloadURL = null;
      return;
    }
    try {
      this.utilityService.openModal();
      if (!this.utilityService.fileExtensionIsValid(attachment.Name)) {
        this.alertCreated.emit({ type: 'danger', msg: 'Attachment has an invalid file extension: ' + attachment.Name });
        return;
      }

      if (this.utilityService.fileIsNotViewable(attachment.Name)) {
        this.pdfUrl = null;
        this.downloadURL = '/Document/GetDBAttachment?attachmentID=' + attachment.ID;
        return;
      }

      this.downloadURL = null;

      if (attachment.Data) {
        const url: string = URL.createObjectURL(attachment.Data);
        const zoom: string = this.defaultZoom ? `#zoom=${this.defaultZoom}` : '';
        const viewerPrefix = '/dist/assets/pdfjs/web/viewer.html?file=';
        const viewerUrl: string = viewerPrefix + url + zoom;
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(viewerUrl);
      } else {
        this.pdfUrl = null;
        this.alertCreated.emit({ type: 'danger', msg: 'Attachment not found' });
      }
    } catch (error) {
      this.alertCreated.emit({ type: 'danger', msg: 'Error loading attachment' });
    } finally {
      this.utilityService.closeModal();
    }
  }
}

export interface Alert {
  type: 'danger' | 'success';
  msg: string;
}

export interface FileInfo {
  ID: string;
  Name: string;
  Data: Blob | null;
}
